export default __webpack_public_path__ + "static/media/168.50e6460b.jpg";